import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { useNavigate } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download'; 
import {
  Container,
  Typography,
  Grid,
  Card,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  styled,
  createTheme,
  ThemeProvider,
  Box,
  CardMedia,
  Button,
} from '@mui/material';
import moment from 'moment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const parcAutomobileData = [
    {
    title: "Parc automobile immatriculé au Burundi au cours de l’année 2023",
    principalLink: "/documents/parc-automobile/Parc_Automobile_Burundi _2023.pdf",
    image: 'assets/annuaires/parc.png',
    description: "Le parc automobile immatriculé au Burundi a enregistré 15 552 nouvelles immatriculations en 2023, ce qui représente une baisse de 4,6 % par rapport à l'année 2022.",
    date: "2024-09-30",
    publicationDate: "2024-09-30",
  },
  {
    title: "Parc automobile immatriculé au Burundi au cours de l’année 2022",
    principalLink: "/documents/parc-automobile/Parc-Automobile-2022.pdf",
    image: 'assets/annuaires/parc.png',
    description: "Le Burundi a enregistré une baisse des immatriculations de véhicules et de motos en 2022 par rapport à 2021, avec 7 903 voitures et 8 405 motos/tricycles, contre 8 067 voitures et 9 491 motos l'année précédente.",
    date: "2024-09-30",
    publicationDate: "2024-09-30",
  },
  {
    title: "Parc automobile immatriculé au Burundi au cours de l’année 2021",
    principalLink: "/documents/parc-automobile/Parc-Automobile-immatricule-au-cours-de-lannee-2021.pdf",
    image: 'assets/annuaires/parc2021.png',
    description: "Le Burundi a enregistré une hausse des immatriculations de véhicules et de motos en 2021 par rapport à 2020, avec 8067  voitures et 9491 motos/tricycles, contre 8150 voitures et 6615 motos l'année précédente.",
    date: "2023-06-30",
    publicationDate: "2023-06-30",
  },
  {
    title: "Parc automobile immatriculé au Burundi au cours de l’année 2020",
    principalLink: "/documents/parc-automobile/Rapport-final-sur-le-Parc-Automobile-au-Burundi-2020.pdf",
 image: 'assets/annuaires/parc2020.png',
 description: "Le Burundi a enregistré une baisse des immatriculations de véhicules et de motos en 2020 par rapport à 2019, avec 8150  voitures et 6615 motos/tricycles, contre 6760 voitures et 4972 motos l'année précédente.",
    date: "2020-12-30",
    publicationDate: "2020-12-30",
  },
  {
    title: "Parc automobile immatriculé au Burundi au cours de l’année 2019",
    principalLink: "/documents/parc-automobile/Parc-automobile-2019-3.pdf",
 image: 'assets/annuaires/parc2020.png',
 description: "Le Burundi a enregistré une hausse des immatriculations de véhicules et de motos en 2019 par rapport à 2018, avec 6760  voitures et 4972 motos/tricycles, contre 6380 voitures et 4010 motos l'année précédente.",
    date: "2019-12-30",
    publicationDate: "2019-12-30",
  },
  {
    title: "Parc automobile immatriculé au Burundi au cours de l’année 2015",
    principalLink: "/documents/parc-automobile/Parc-Auto-mobile-2015VF.pdf",
 image: 'assets/annuaires/parc2020.png',
 description: "Le Burundi a enregistré une baisse des immatriculations de véhicules et de motos en 2015 par rapport à 2014, avec 7402  voitures et 5229 motos/tricycles, contre 7541 voitures et 5764 motos l'année précédente.",
    date: "2015-12-30",
    publicationDate: "2015-12-30",
  },
  {
    title: "Parc automobile immatriculé au Burundi au cours de l’année 2013",
    principalLink: "/documents/parc-automobile/Parc-Automobile-2013.pdf",
 image: 'assets/annuaires/parc2020.png',
 description: "Le Burundi a enregistré une baisse des immatriculations de véhicules et de motos en 2013 par rapport à 2012, avec 50 670 voitures et 28 697 motos/tricycles, contre 6760 voitures et 4972 motos l'année précédente.",
    date: "2013-12-30",
    publicationDate: "2013-12-30",
  },
];

function ParcAutomobile() {
  const [visibleCount, setVisibleCount] = useState(4);
  const [selectedYear, setSelectedYear] = useState('Tous');
  const [filteredParc, setFilteredParc] = useState(parcAutomobileData);
  const navigate = useNavigate();

  const handleShowMore = () => {
    setVisibleCount((prevCount) => prevCount + 2);
  };

  const handleYearChange = (event) => {
    const year = event.target.value;
    setSelectedYear(year);
    if (year === 'Tous') {
      setFilteredParc(parcAutomobileData);
    } else {
      const filtered = parcAutomobileData.filter((parc) => {
        const parcYear = new Date(parc.date).getFullYear();
        return parcYear === parseInt(year);
      });
      setFilteredParc(filtered);
    }
  };

  const StyledSelect = styled(Select)(({ theme }) => ({
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.dark,
    },
  }));

  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C',
      },
      background: {
        default: '#f5f5f5',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />

        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main }}>
            Parc Automobile au Burundi
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Le parc automobile du Burundi est une publication annuelle qui répond aux besoins ressentis par plusieurs utilisateurs. Elle met à leur disposition des données permettant de planifier, notamment en ce qui concerne les pièces de rechange et l’infrastructure routière. L’édition de 2020 suit les autres éditions produites pour les années 2013 à 2019, une reprise d'une publication suspendue en 2002 par manque de ressources humaines compétentes pour le faire.
          </Typography>

          <FormControl fullWidth variant="outlined" style={{ marginLeft: '0px', width: '300px' }}>
            <InputLabel id="year-select-label">Sélectionner par l'année de publication</InputLabel>
            <StyledSelect
              labelId="year-select-label"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              label="Sélectionner par l'année de publication"
            >
              <MenuItem value="Tous">Tous les rapports</MenuItem>
              {[...new Set(parcAutomobileData.map((parc) => new Date(parc.date).getFullYear()))]
                .sort((a, b) => b - a) 
                .map((year) => (
                  <MenuItem key={year} value={year.toString()}>
                    {year}
                  </MenuItem>
                ))}
            </StyledSelect>
          </FormControl>

          {/* Affichage des données du parc automobile */}
          <Grid container spacing={1} style={{ marginTop: '10px' }}>
            {filteredParc.slice(0, visibleCount).map((parc, index) => (
              <Grid item xs={12} sm={12} key={index}>
                <Card elevation={3} style={{ borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ display: 'flex' }}>
                    <a
                      href={parc.principalLink}
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <CardMedia
                        component="img"
                        sx={{ width: 71, height: 120, m: 2 }}
                        image={parc.image}
                        alt={parc.title}
                      />
                    </a>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                      <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px' }}>
                        <a
                          href={parc.principalLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: 'none', color: theme.palette.primary.main }}
                        >
                           {<DownloadIcon />}{parc.title}
                        </a>
                      </Typography>
                      <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                        {parc.description}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        Publié en {moment(parc.publicationDate).format('MMMM YYYY')}
                      </Typography>
                    </Box>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>

          {visibleCount < filteredParc.length && (
            <Button
              onClick={handleShowMore}
              style={{
                marginTop: '20px',
                marginBottom: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              Plus de Rapports
            </Button>
          )}

          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Button
                onClick={() => navigate('/annuaire')}
              style={{
                marginTop: '5px',
                backgroundColor: theme.palette.primary.main,
                color: 'white',
              }}
            >
              <ArrowBackIcon style={{ marginRight: '8px' }} />
              Retour à la page principale
            </Button>
          </Box>
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default ParcAutomobile;